
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-guides",
      function () {
        return require("private-next-pages/travel-guides/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-guides"])
      });
    }
  